import { Grid } from "@mui/material";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import WSDataGridNew, { IColumns } from "../../../Components/DataGrid/WSDataGridNew";
import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
import WSButton from "../../../Components/Button/WSButton";
import AddIcon from "@mui/icons-material/Add";
import { callAPI, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import PopoverFormWrapper from "../../../Components/PopOverSubmit/PopoverFormWrapper";
import { Specialization } from "./SpecializationCreate";
import { useForm } from "react-hook-form";
import { usePopover } from "../../../Components/PopOverSubmit/PopOverContext";

export const SpecializationList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { openPopover } = usePopover();
  const popoverAnchorRef = useRef<HTMLDivElement>(null);
  const {
    control,    register,    handleSubmit,    reset,    setValue,    watch,  } = useForm();

  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const { add, edit, remove } = getPermissions("specialization"); // role permissions for this page
  const filters = ["All Records"];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);
  // Using global popover (usePopover); no local anchor state needed

  const [productSource, setProductSource] = useState<any>({
    url: "Specialization/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  });
  const source = {
    url: "Specialization/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };

  useEffect(() => {
    updateMainHeader("Specialization");
  });

  breadCrumbsStore.updateBreadCrumbs([
    { "Specialization List": "/specialization/list" },
  ]);
  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any, event?: React.MouseEvent<HTMLElement>) => {
    if (action === "Edit") {
      navigate(`/specialization/edit/${row?.id}`)
      // openPopover({
      //   anchorEl: (event?.currentTarget as HTMLElement) ?? popoverAnchorRef.current ?? undefined,
      //   Component: Specialization,
      //   showSaveAndNew: false,
      //   anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
      //   transformOrigin: { vertical: 'top', horizontal: 'left' },
      //   componentProps: {
      //     control,
      //     register,
      //     setValue,
      //     reset,
      //     id: row?.id,
      //     data: row,
      //     onCancel: () => {},
      //     onSave: handleData,
      //     onSaveAndNew: handleDataSaveAndNew,
      //   },
      // });
    }
    if (action === "Delete") {
      setSelectedId(row.id); // Set the ID of the row to be deleted
      setPopupOpen(true);
    }
  };

  const handleFilter = (value: any) => {
    let soureFilter: any = {
      url: "Specialization/search",
      page: 1,
      pageSize: 10,
      filter: [],
      sort: [
        {
          field: "UpdatedAt",
          direction: "desc",
        },
      ],
    };
    switch (value) {
      case "In Stock":
        soureFilter.filter = [
          {
            field: "name",
            operator: "eq",
            value: "In Stock",
          },
        ];
        break;
    }
    //  setProductSource({ ...soureFilter });
  };

  const columns: IColumns[] = [
    {
      header: "Image",
      fieldName: "imageUrl",
      type: "img",
    },
    {
      header: "Name",
      fieldName: "specializations",
      tooltip: true,
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit && "Edit", remove && "Delete"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];

  const handleClick = () => {
    navigate("/specialization/create");
  };
  const handleDelete = (response: any) => {
    dispatch(resetDataComponent("specializationGrid"));
    showMessage("Specialization deleted successfully!", "success");
  };
  const handleDataSaveAndNew = async (data: any) => {
    try {
      setLoadingSaveAndNew(true);
      const response: any = await saveData(data);
      if (response && response?.message) {
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
        if (response.success === true) {
          reset();
        }
      } else if (response?.id) {
        reset();
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoadingSaveAndNew(false);
    }
  };
  const handleData = async (data: any) => {
    try {
      setLoading(true);
      
      const response: any = await saveData(data);
      if (response && response?.message) {
        dispatch(resetDataComponent("specializationGrid"));
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
        if (response.success === true) {
          navigate(`/specialization/list`);
        }
      } else if (response?.id) {
        dispatch(resetDataComponent("specializationGrid"));
        showMessage("specialization Created Successfully", "success");
        navigate(`/specialization/list`);
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoading(false);
    }
  };

  const saveData = async (data: any) => {
    const request: any = {
      specializations: data?.specializations || "",
    };
    if (data?.specializationId) {
      const response: any = await callAPI(
        "Specialization",
        Method.PUT,
        request,
        data.specializationId
      );
      return response;
    } else {
      const response: any = await callAPI(
        "Specialization",
        Method.POST,
        request
      );
      return response;
    }
  };
  const handleAddClick = (event: React.MouseEvent<HTMLElement>) => {
    // reset({ specializations: "", specializationId: undefined });
    // openPopover({
    //   anchorEl: event.currentTarget,
    //   Component: Specialization,
    //   showSaveAndNew: true,
    //   anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    //   transformOrigin: { vertical: 'top', horizontal: 'left' },
    //   componentProps: {
    //     control,
    //     register,
    //     setValue,
    //     reset,
    //     id: undefined,
    //     onCancel: () => {},
    //     onSave: handleData,
    //     onSaveAndNew: handleDataSaveAndNew,
    //   },
    // });
  };

  return (
    <Grid p={3}>
      {/* <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="specializationGrid"
            title="Specialization"
            columns={columns}
            source={source}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
          {selectedId !== null && (
            <ConfirmationPopup
             type="DELETE"
              apiUrl={"Specialization"}
              id={selectedId}
              confirmMessage="Are you sure you want to delete this item?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleDelete}
            />
          )}
        </Grid>
      </Grid> */}

      <Grid container spacing={2}>
        <Grid item sm={9}>
          <WSFilterButtonGroup
            options={filters}
            selected={selectedFilter}
            onChange={(value) => {
              setSelectedFilter(value);
              handleFilter(value);
            }}
          />
        </Grid>
        <Grid item sm={3} display="flex" justifyContent={"flex-end"}>
          <WSButton
            id="btnAddNewProduct"

            label="Add Specialization"
            startIcon={<AddIcon />}
            onClick={handleClick}

            sx={{
              borderRadius: "999px", // pill shape
              backgroundColor: "#098963!important", // green background
              textTransform: "none", // prevent uppercase
              fontWeight: 500,
              height: "35px!important",
              fontSize: "0.875rem!important",
              paddingX: 3,
              paddingY: 1,
              "&:hover": {
                backgroundColor: "#087654!important",
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <div ref={popoverAnchorRef}>
          {productSource && (
            <WSDataGridNew
              id="specializationGrid"
              title="Specialization"
              columns={columns}
              source={productSource}
              searchBox={{ fieldName: "specializations" }}
              addButton={add ? { label: "New", color: "secondary" } : undefined}
              onAddButtonClick={handleClick}
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
            />
          )}
          </div>
          {selectedId !== null && (
            <ConfirmationPopup
              type="DELETE"
              apiUrl={"Specialization"}
              id={selectedId}
              confirmMessage="Are you sure you want to delete this item?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleDelete}
            />
          )}
          {/* PopoverFormWrapper removed in favor of global popover via usePopover */}

        </Grid>
      </Grid>
    </Grid>
  );
});
